// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SiHaDocumentationListPagingResultModel from '../../model/si-ha-documentation-list-paging-result-model';
import SiHaDocumentationListPagingResultDTO from '../dto/si-ha-documentation-list-paging-result-dto';
import dtoSchema from '../schemas/si-ha-documentation-list-paging-result-schema';
import SiHaDocumentationListModel from '../../model/si-ha-documentation-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class SiHaDocumentationListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SiHaDocumentationListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SiHaDocumentationListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: SiHaDocumentationListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<SiHaDocumentationListPagingResultDTO>): SiHaDocumentationListPagingResultModel;
  static toModel(dto: DeepPartial<SiHaDocumentationListPagingResultDTO> | undefined | null): SiHaDocumentationListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<SiHaDocumentationListPagingResultDTO> | undefined | null): SiHaDocumentationListPagingResultModel | undefined {
    return dto ? new SiHaDocumentationListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SiHaDocumentationListPagingResultModel> | SiHaDocumentationListPagingResultModel): SiHaDocumentationListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as SiHaDocumentationListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SiHaDocumentationListPagingResultModel, can not map to SiHaDocumentationListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
